module.exports = __webpack_public_path__ + "media/src/images/graph_exp03-dac50f13152a9cfe5817528d14214d47.png";